import type { SchemaPartnerResolver_GetMyPartnerContact } from 'cpool-tables/backend-resolvers';
import { LuUser } from 'react-icons/lu';

type Props = {
    contact: SchemaPartnerResolver_GetMyPartnerContact;
    disabled: boolean;
    disabledReason?: string;
    onClick: () => void;
};

export const PartnerContactListItem = ({ contact, disabled, disabledReason, onClick }: Props) => (
    <button
        type="button"
        onClick={onClick}
        disabled={disabled}
        title={disabledReason}
        className="flex w-full items-center gap-3 rounded-md bg-white px-3 py-2 text-left hover:bg-surface-light disabled:cursor-not-allowed disabled:opacity-60"
        data-testid="partner-contact-list-item"
    >
        <span className="flex size-6 shrink-0 items-center justify-center rounded-full bg-grey-light text-grey">
            <LuUser className="size-3.5" />
        </span>
        <span className="truncate text-sm font-semibold text-midnight">{contact.name}</span>
    </button>
);
